module.exports = __webpack_public_path__ + "img/img7.18a51eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img7.jpg
// module id = 343
// module chunks = 0